var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDotSpinner = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.314,
    height: 24.314,
    viewBox: "0 0 24.314 24.314",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "spinner_small_1",
    transform: "translate(-133 -1834.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5157",
    "data-name": "Group 5157",
    transform: "translate(133.423 1834.423)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 0.74,
    cy: 0.74,
    r: 0.74,
    transform: "translate(0 11.036)",
    fill: "rgba(245,248,250,0.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(21.891 11.086)",
    fill: "rgba(245,248,250,0.8)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_209",
    "data-name": "Ellipse 209",
    cx: 0.951,
    cy: 0.951,
    rx: 0.951,
    ry: 0.951,
    transform: "translate(1.865 5.058) rotate(30)",
    fill: "rgba(245,248,250,0.4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    cx: 1.162,
    cy: 1.162,
    rx: 1.162,
    ry: 1.162,
    transform: "translate(20.766 15.785) rotate(30)",
    fill: "rgba(245,248,250,0.8)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 0.951,
    cy: 0.951,
    rx: 0.951,
    ry: 0.951,
    transform: "translate(6.665 0.932) rotate(60)",
    fill: "rgba(245,248,250,0.5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 1.268,
    cy: 1.268,
    rx: 1.268,
    ry: 1.268,
    transform: "translate(17.784 19.41) rotate(60)",
    fill: "#f5f8fa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    "data-name": "Ellipse 205",
    cx: 0.951,
    cy: 0.951,
    r: 0.951,
    transform: "translate(12.68 0) rotate(90)",
    fill: "rgba(245,248,250,0.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_207",
    "data-name": "Ellipse 207",
    cx: 1.31,
    cy: 1.31,
    r: 1.31,
    transform: "translate(12.992 20.888) rotate(90)",
    fill: "#f5f8fa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    cx: 0.951,
    cy: 0.951,
    rx: 0.951,
    ry: 0.951,
    transform: "translate(18.715 1.889) rotate(120)",
    fill: "rgba(245,248,250,0.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_208",
    "data-name": "Ellipse 208",
    cx: 0.317,
    cy: 0.317,
    rx: 0.317,
    ry: 0.317,
    transform: "translate(6.888 21.212) rotate(120)",
    fill: "rgba(245,248,250,0.1)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_203",
    "data-name": "Ellipse 203",
    cx: 0.951,
    cy: 0.951,
    rx: 0.951,
    ry: 0.951,
    transform: "translate(22.846 6.718) rotate(150)",
    fill: "rgba(245,248,250,0.7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_210",
    "data-name": "Ellipse 210",
    cx: 0.528,
    cy: 0.528,
    rx: 0.528,
    ry: 0.528,
    transform: "translate(3.1 17.822) rotate(150)",
    fill: "rgba(245,248,250,0.2)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2373",
    "data-name": "Rectangle 2373",
    width: 24.314,
    height: 24.314,
    transform: "translate(133 1834.285)",
    fill: "none"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDotSpinner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DotSpinner.d7a7563a4fa2be8d714e387b97ab3f3d.svg";